var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2654",
    "data-name": "Group 2654",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.017,
    height: 35.017,
    viewBox: "0 0 35.017 35.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M-127.235,172.077h0a17.509,17.509,0,0,1-17.508-17.509h0a17.508,17.508,0,0,1,17.508-17.508h0a17.508,17.508,0,0,1,17.509,17.508h0A17.509,17.509,0,0,1-127.235,172.077Z",
    transform: "translate(144.743 -137.06)",
    fill: "#222221"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898",
    transform: "translate(7.908 7.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M-126.548,147.386c2.564,0,2.868.009,3.88.056a5.3,5.3,0,0,1,1.782.33,2.972,2.972,0,0,1,1.1.718,2.993,2.993,0,0,1,.719,1.1,5.327,5.327,0,0,1,.33,1.783c.046,1.012.056,1.316.056,3.879s-.01,2.867-.056,3.88a5.325,5.325,0,0,1-.33,1.782,2.986,2.986,0,0,1-.719,1.1,2.972,2.972,0,0,1-1.1.718,5.313,5.313,0,0,1-1.782.331c-1.012.046-1.316.055-3.88.055s-2.867-.009-3.879-.055a5.313,5.313,0,0,1-1.782-.331,2.964,2.964,0,0,1-1.1-.718,2.974,2.974,0,0,1-.719-1.1,5.3,5.3,0,0,1-.33-1.782c-.046-1.013-.056-1.317-.056-3.88s.01-2.867.056-3.879a5.3,5.3,0,0,1,.33-1.783,2.981,2.981,0,0,1,.719-1.1,2.964,2.964,0,0,1,1.1-.718,5.3,5.3,0,0,1,1.782-.33c1.012-.047,1.316-.056,3.879-.056m0-1.73c-2.606,0-2.934.011-3.958.057a7.055,7.055,0,0,0-2.33.447,4.7,4.7,0,0,0-1.7,1.107,4.7,4.7,0,0,0-1.107,1.7,7.03,7.03,0,0,0-.446,2.33c-.047,1.024-.058,1.351-.058,3.958s.011,2.934.058,3.958a7.03,7.03,0,0,0,.446,2.33,4.7,4.7,0,0,0,1.107,1.7,4.712,4.712,0,0,0,1.7,1.108,7.059,7.059,0,0,0,2.33.446c1.024.047,1.352.058,3.958.058s2.934-.011,3.959-.058a7.047,7.047,0,0,0,2.329-.446,4.715,4.715,0,0,0,1.7-1.108,4.71,4.71,0,0,0,1.107-1.7,7.054,7.054,0,0,0,.446-2.33c.047-1.024.058-1.351.058-3.958s-.011-2.934-.058-3.958a7.054,7.054,0,0,0-.446-2.33,4.71,4.71,0,0,0-1.107-1.7,4.7,4.7,0,0,0-1.7-1.107,7.044,7.044,0,0,0-2.329-.447c-1.025-.046-1.352-.057-3.959-.057",
    transform: "translate(136.147 -145.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M-126.142,150.732a4.93,4.93,0,0,0-4.929,4.93,4.93,4.93,0,0,0,4.929,4.929,4.93,4.93,0,0,0,4.93-4.929,4.93,4.93,0,0,0-4.93-4.93m0,8.129a3.2,3.2,0,0,1-3.2-3.2,3.2,3.2,0,0,1,3.2-3.2,3.2,3.2,0,0,1,3.2,3.2,3.2,3.2,0,0,1-3.2,3.2",
    transform: "translate(135.741 -146.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M-119.09,150.42a1.152,1.152,0,0,1-1.153,1.152,1.152,1.152,0,0,1-1.152-1.152,1.152,1.152,0,0,1,1.152-1.152,1.153,1.153,0,0,1,1.153,1.152",
    transform: "translate(134.967 -145.945)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ab90e05f0b80e716593927f9ed1946b4.svg";
export { ForwardRef as ReactComponent };